export function isWatermarkAvailable(file: File) {
  const fileExtension = file.name.toLowerCase().split('.').pop();
  const allowedExtensions = ['jpg', 'png', 'jpeg', 'bmp', 'tiff', 'webp', 'jfif', 'heif', 'heic', 'avif'];
  return allowedExtensions.indexOf(fileExtension) > -1;
}
